export enum ATDLNOrientation {
  HORIZONTAL,
  VERTICAL,
}
